<template>
	<div>
		<md-button style="min-width: 40%; height: 35px;"
				   class="md-primary"
				   @click="apply()">{{ $t("investor.exchange.table.operation.bid.button") }}
		</md-button>
	</div>
</template>

<script>

export default {
	methods: {
		apply() {
			this.params.bidOnSingle(this.params.data);
		}
	}
};
</script>